import { TabbedFlipboardSmallMediaCardType } from '@models/ITabbedFlipboard';
import TabbedFlipboardMediaCard from './TabbedFlipboardMediaCard';

const TabbedFlipboardSmallMediaCard = ({
  headline,
  media,
  meta,
}: Omit<TabbedFlipboardSmallMediaCardType, 'type'>) => (
  <TabbedFlipboardMediaCard
    headline={headline}
    media={media}
    meta={meta}
    dataTestId="CT-159-Tabbed-Flipboard-Small-Media-Card"
    isSmall
  />
);

export default TabbedFlipboardSmallMediaCard;
